import { FolderLock } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const hrRecordsNav: NavEntry = {
  label: 'HR records',
  icon: FolderLock,
  path: '/people/hr-records',
  permission: 'hr_records:read_own',
  order: 24,
}
